import React from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import { useTranslation } from "react-i18next";

import { StyledGoToBackWrapper } from "./styledGoToBack";

const GoToBackButton = ({as, to, pt, pb, handler}) => {
  const { t } = useTranslation("otherInterface");

  return (
    <StyledGoToBackWrapper pt={pt} pb={pb}>
      <DefaultButton onClick={handler} component={as} color="transparent" to={to}>
        <span className="icon-light-arrow-left"/>
        {t("goBackButton.description")}
      </DefaultButton>
    </StyledGoToBackWrapper>
  )
}

export default GoToBackButton